export const links = [
  { url: '/', text: 'Vision' },
  { url: '/team/', text: 'Team' },
  { url: '/projects/', text: 'Projects' },
  { url: '/press/', text: 'Press' },
  { url: '/contact/', text: 'Contact' }
]
